var render = function render(){var _vm=this,_c=_vm._self._c;return _c('organisation-add',{attrs:{"show":_vm.showOrganisationAdd,"title":'Set up an organisation to continue',"closable":false},on:{"added":_vm.added}})
}
var staticRenderFns = []

export { render, staticRenderFns }